

export default {
  locale: 'zh-cn',
  Pagination: {
    items_per_page: '条/页',
    jump_to: '跳至',
    jump_to_confirm: '确定',
    page: '页',
    prev_page: '上一页',
    next_page: '下一页',
    prev_5: '向前 5 页',
    next_5: '向后 5 页',
    prev_3: '向前 3 页',
    next_3: '向后 3 页',
    page_size: '页码'
  },
  DatePicker: {
    lang: {
      placeholder: '请选择日期',
      yearPlaceholder: '请选择年份',
      quarterPlaceholder: '请选择季度',
      monthPlaceholder: '请选择月份',
      weekPlaceholder: '请选择周',
      rangePlaceholder: ['开始日期', '结束日期'],
      rangeYearPlaceholder: ['开始年份', '结束年份'],
      rangeMonthPlaceholder: ['开始月份', '结束月份'],
      rangeWeekPlaceholder: ['开始周', '结束周'],
      locale: 'zh_CN',
      today: '今天',
      now: '此刻',
      backToToday: '返回今天',
      ok: '确定',
      timeSelect: '选择时间',
      dateSelect: '选择日期',
      weekSelect: '选择周',
      clear: '清除',
      month: '月',
      year: '年',
      previousMonth: '上个月 (翻页上键)',
      nextMonth: '下个月 (翻页下键)',
      monthSelect: '选择月份',
      yearSelect: '选择年份',
      decadeSelect: '选择年代',
      yearFormat: 'YYYY年',
      dayFormat: 'D日',
      dateFormat: 'YYYY年M月D日',
      dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
      previousYear: '上一年 (Control键加左方向键)',
      nextYear: '下一年 (Control键加右方向键)',
      previousDecade: '上一年代',
      nextDecade: '下一年代',
      previousCentury: '上一世纪',
      nextCentury: '下一世纪'
    },
    timePickerLocale: {
      placeholder: '请选择时间',
      rangePlaceholder: ['开始时间', '结束时间']
    }
  },
  TimePicker: {
    placeholder: '请选择时间',
    rangePlaceholder: ['开始时间', '结束时间']
  },
  Calendar: {
    lang: {
      placeholder: '请选择日期',
      yearPlaceholder: '请选择年份',
      quarterPlaceholder: '请选择季度',
      monthPlaceholder: '请选择月份',
      weekPlaceholder: '请选择周',
      rangePlaceholder: ['开始日期', '结束日期'],
      rangeYearPlaceholder: ['开始年份', '结束年份'],
      rangeMonthPlaceholder: ['开始月份', '结束月份'],
      rangeWeekPlaceholder: ['开始周', '结束周'],
      locale: 'zh_CN',
      today: '今天',
      now: '此刻',
      backToToday: '返回今天',
      ok: '确定',
      timeSelect: '选择时间',
      dateSelect: '选择日期',
      weekSelect: '选择周',
      clear: '清除',
      month: '月',
      year: '年',
      previousMonth: '上个月 (翻页上键)',
      nextMonth: '下个月 (翻页下键)',
      monthSelect: '选择月份',
      yearSelect: '选择年份',
      decadeSelect: '选择年代',
      yearFormat: 'YYYY年',
      dayFormat: 'D日',
      dateFormat: 'YYYY年M月D日',
      dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
      previousYear: '上一年 (Control键加左方向键)',
      nextYear: '下一年 (Control键加右方向键)',
      previousDecade: '上一年代',
      nextDecade: '下一年代',
      previousCentury: '上一世纪',
      nextCentury: '下一世纪'
    },
    timePickerLocale: {
      placeholder: '请选择时间',
      rangePlaceholder: ['开始时间', '结束时间']
    }
  },
  global: {
    placeholder: '请选择'
  },
  Table: {
    filterTitle: '筛选',
    filterConfirm: '确定',
    filterReset: '重置',
    filterEmptyText: '无筛选项',
    selectAll: '全选当页',
    selectInvert: '反选当页',
    selectionAll: '全选所有',
    sortTitle: '排序',
    expand: '展开行',
    collapse: '关闭行',
    triggerDesc: '点击降序',
    triggerAsc: '点击升序',
    cancelSort: '取消排序',
    filterCheckall: '全选',
    filterSearchPlaceholder: '在筛选项中搜索',
    selectNone: '清空所有'
  },
  Modal: {
    okText: '确定',
    cancelText: '取消',
    justOkText: '知道了'
  },
  Popconfirm: {
    cancelText: '取消',
    okText: '确定'
  },
  Transfer: {
    searchPlaceholder: '请输入搜索内容',
    itemUnit: '项',
    itemsUnit: '项',
    remove: '删除',
    selectCurrent: '全选当页',
    removeCurrent: '删除当页',
    selectAll: '全选所有',
    removeAll: '删除全部',
    selectInvert: '反选当页'
  },
  Upload: {
    uploading: '文件上传中',
    removeFile: '删除文件',
    uploadError: '上传错误',
    previewFile: '预览文件',
    downloadFile: '下载文件'
  },
  Empty: {
    description: '暂无数据'
  },
  Icon: {
    icon: '图标'
  },
  Text: {
    edit: '编辑',
    copy: '复制',
    copied: '复制成功',
    expand: '展开'
  },
  PageHeader: {
    back: '返回'
  },
  Image: {
    preview: '预览'
  },
  CronExpression: {
    cronError: 'cron 表达式不合法',
    second: '秒',
    minute: '分钟',
    hour: '小时',
    day: '日',
    month: '月',
    week: '周',
    secondError:
      '<p><span>*</span>任意值</p><p><span>,</span>多个值之间的分隔符</p><p><span>-</span>区间值的连接符</p><p><span>/</span>平均分配</p><p><span>0-59</span>允许范围</p>',
    minuteError:
      '<p><span>*</span>任意值</p><p><span>,</span>多个值之间的分隔符</p><p><span>-</span>区间值的连接符</p><p><span>/</span>平均分配</p><p><span>0-59</span>允许范围</p>',
    hourError:
      '<p><span>*</span> 任意值</p><p><span>,</span> 多个值之间的分隔符</p><p><span>-</span> 区间值的连接符</p><p><span>/</span> 平均分配</p><p><span>0-23</span> 允许范围</p>',
    dayError:
      '<p><span>*</span> 任意值</p><p><span>,</span> 多个值之间的分隔符</p><p><span>-</span> 区间值的连接符</p><p><span>/</span> 平均分配</p><p><span>1-31</span> 允许范围</p>',
    monthError:
      '<p><span>*</span> 任意值</p><p><span>,</span> 多个值之间的分隔符</p><p><span>-</span> 区间值的连接符</p><p><span>/</span> 平均分配</p><p><span>1-12</span> 允许范围</p>',
    weekError:
      '<p><span>*</span> 任意值</p><p><span>,</span> 多个值之间的分隔符</p><p><span>-</span> 区间值的连接符</p><p><span>/</span> 平均分配</p><p><span>?</span> 不指定</p><p><span>0-7</span> 允许范围（0代表周日，1-7依次为周一到周日）</p>'
  },
  QRCode: {
    expired: '二维码过期',
    refresh: '点击刷新'
  }
};
